import styled from 'styled-components';

import { subcategorySource } from 'data/entity-sources/sources';
import { useScopedEntitySource } from 'data/entity-sources/useEntityOptions';

import { UltraSelectField } from 'components/UltraSelect';

export const SubcategorySelector = ({ categoryId }: { categoryId: string }) => {
    // Le périmètre n'est connu qu'au rendu : `useScopedEntitySource` mémoïse sur sa valeur, pas sur
    // l'identité de l'objet — sinon la source changerait à chaque rendu et relancerait la recherche.
    const source = useScopedEntitySource(subcategorySource, { categoryIds: [categoryId] });

    return (
        <Row key={categoryId}>
            ↳
            <UltraSelectField
                source={source}
                label="Sous-catégorie"
                placeholder="Sélectionner une sous-catégorie"
                name="subcategoryId"
                dataTest="product-subcategory"
                isClearable
            />
        </Row>
    );
};

const Row = styled.div`
    display: flex;
    flex-direction: row;
    color: white;
    gap: 5px;
`;
